import { render } from "./MediaflowEditorPanel.vue?vue&type=template&id=05367b5c&scoped=true"
import script from "./MediaflowEditorPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowEditorPanel.vue?vue&type=script&setup=true&lang=js"

import "./MediaflowEditorPanel.vue?vue&type=style&index=0&id=05367b5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05367b5c"],['__file',"src/components/Mediaflow/MediaflowEditorPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05367b5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05367b5c', __exports__)) {
    api.reload('05367b5c', __exports__)
  }
  
  module.hot.accept("./MediaflowEditorPanel.vue?vue&type=template&id=05367b5c&scoped=true", () => {
    api.rerender('05367b5c', render)
  })

}


export default __exports__